export const DSA_VERIFICATION_BASE_PATH = '/dsa-verification';
export const DSA_VERIFICATION_ERROR_PATH = `${DSA_VERIFICATION_BASE_PATH}/error`;
export const DSA_DOCUMENTS_PENDING_PATH = `${DSA_VERIFICATION_BASE_PATH}/document-uploading`;
export const DSA_DOCUMENTS_IN_REVIEW_PATH = `${DSA_VERIFICATION_BASE_PATH}/documents-in-review`;
export const DSA_DOCUMENTS_REVIEWED_PATH = `${DSA_VERIFICATION_BASE_PATH}/documents-reviewed`;
export const DSA_DOCUMENT_CHECK_FAILED_ROUTE_PATH = 'document-check-failed';
export const DSA_DOCUMENT_CHECK_FAILED_PATH = `${DSA_VERIFICATION_BASE_PATH}/${DSA_DOCUMENT_CHECK_FAILED_ROUTE_PATH}`;
